import React from "react";

export default function ApplicationOverview({
  selectedMember,
  applicationList,
  productVault,
  handleMemberMarketplace,
  formatPhoneNumber,
}) {
  return (
    <div>
      {/* You are viewing section */}
      <div className="row mb-4">
        <div className="col-12">
          <div
            className="card"
            style={{
              border: "1px solid #e9ecef",
              borderRadius: "8px",
              padding: "20px",
            }}
          >
            <h6
              className="mb-3"
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#495057",
              }}
            >
              You are viewing:
            </h6>
            <div className="row">
              <div className="col-md-8">
                <h4
                  className="mb-2"
                  style={{ fontWeight: "600", color: "#2c3e50" }}
                >
                  {selectedMember?.firstName || ""}{" "}
                  {selectedMember?.lastName || ""}
                </h4>
                <div className="row">
                  <div className="col-md-4 mb-2">
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        fontWeight: "600",
                      }}
                    >
                      STATUS:
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#28a745",
                        fontWeight: "500",
                      }}
                    >
                      Active
                    </div>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        fontWeight: "600",
                      }}
                    >
                      MEMBERSHIP ID:
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#2c3e50",
                        fontWeight: "500",
                      }}
                    >
                      {selectedMember?.memberNumber || "M-590398392"}
                    </div>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        fontWeight: "600",
                      }}
                    >
                      MEMBERSHIP TYPE:
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#2c3e50",
                        fontWeight: "500",
                      }}
                    >
                      Personal
                    </div>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        fontWeight: "600",
                      }}
                    >
                      MEMBER ROLE:
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#2c3e50",
                        fontWeight: "500",
                      }}
                    >
                      Primary account holder
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Additional or related memberships */}
      {/* Commented out for phase 1 demos - ticket SIBM-382, remove comments later - CH */}
      {/* <div className="row mb-4">
        <div className="col-12">
          <h6
            className="mb-3"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#495057",
            }}
          >
            Additional or related memberships:
          </h6>
          <div className="row"> */}
      {/* Membership cards dummy data*/}
      {/* {[
              {
                id: "M-590398555",
                type: "Personal",
                role: "Primary",
                color: "#e91e63",
              },
              {
                id: "M-590398000",
                type: "Personal",
                role: "Primary",
                color: "#e91e63",
              },
              {
                id: "M-590398111",
                type: "Personal",
                role: "Secondary",
                color: "#e91e63",
              },
              {
                id: "M-B903900",
                type: "Business",
                role: "Authorized Signatory",
                color: "#e91e63",
              },
              {
                id: "M-B903098",
                type: "Business",
                role: "Owner",
                color: "#e91e63",
              },
            ].map((membership, index) => (
              <div key={index} className="col-md-6 col-lg-4 mb-3"> */}
      {/* Membership card temmplate*/}
      {/* <div
                  className="card h-100"
                  style={{
                    border: "1px solid #e9ecef",
                    borderRadius: "8px",
                    padding: "16px",
                    position: "relative",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#2c3e50",
                          marginBottom: "8px",
                        }}
                      >
                        {membership.id}
                      </h6>
                      <div className="mb-1">
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#6c757d",
                            fontWeight: "600",
                          }}
                        >
                          Membership Type:
                        </span>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#2c3e50",
                            marginLeft: "8px",
                          }}
                        >
                          {membership.type}
                        </span>
                      </div>
                      <div>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#6c757d",
                            fontWeight: "600",
                          }}
                        >
                          Member Role:
                        </span>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#2c3e50",
                            marginLeft: "8px",
                          }}
                        >
                          {membership.role}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        backgroundColor: membership.color,
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <i
                        className="fas fa-external-link-alt"
                        style={{ color: "white", fontSize: "12px" }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Portfolio Metrics and Activity Timeline */}
      <div className="row">
        {/* Portfolio Metrics */}
        <div className="col-md-8">
          <div
            className="card"
            style={{
              border: "1px solid #e9ecef",
              borderRadius: "8px",
              padding: "20px",
              marginBottom: "20px",
            }}
          >
            <h6
              className="mb-4"
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#495057",
              }}
            >
              Portfolio Metrics
            </h6>

            {/* Key metrics */}
            <div className="row mb-4">
              <div className="col-md-4 text-center">
                <div
                  style={{
                    fontSize: "28px",
                    fontWeight: "600",
                    color: "#17a2b8",
                    marginBottom: "8px",
                  }}
                >
                  8 yrs 3 mos
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#6c757d",
                    fontWeight: "500",
                  }}
                >
                  Member Relationship
                </div>
              </div>
              <div className="col-md-4 text-center">
                <div
                  style={{
                    fontSize: "28px",
                    fontWeight: "600",
                    color: "#17a2b8",
                    marginBottom: "8px",
                  }}
                >
                  $ 210,000
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#6c757d",
                    fontWeight: "500",
                  }}
                >
                  Net worth
                </div>
              </div>
              <div className="col-md-4 text-center">
                <div
                  style={{
                    fontSize: "28px",
                    fontWeight: "600",
                    color: "#17a2b8",
                    marginBottom: "8px",
                  }}
                >
                  $ 120,000
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#6c757d",
                    fontWeight: "500",
                  }}
                >
                  Total Loan Balance
                </div>
              </div>
            </div>

            {/* Product counts */}
            <div className="row mb-4">
              {[
                { label: "Accounts", count: 2 },
                { label: "Registered Products", count: 3 },
                { label: "Lending Products", count: 1 },
                { label: "Mortgages", count: 1 },
                { label: "Credit Cards", count: 0 },
                { label: "Insurance", count: 0 },
                { label: "Other", count: 1 },
              ].map((item, index) => (
                <div key={index} className="col text-center">
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      color: "#2c3e50",
                      marginBottom: "4px",
                    }}
                  >
                    {item.count}
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#6c757d",
                      fontWeight: "500",
                    }}
                  >
                    {item.label}
                  </div>
                </div>
              ))}
            </div>

            {/* Activity Trend Chart */}
            <div className="mb-4">
              <h6
                className="mb-3"
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#495057",
                }}
              >
                Activity Trend
              </h6>
              <div
                style={{
                  height: "120px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #e9ecef",
                }}
              >
                <div className="text-center">
                  <i
                    className="fas fa-chart-line"
                    style={{
                      fontSize: "24px",
                      color: "#6c757d",
                      marginBottom: "8px",
                    }}
                  ></i>
                  <div style={{ fontSize: "14px", color: "#6c757d" }}>
                    Activity trend chart would be displayed here
                  </div>
                </div>
              </div>
              <div
                className="mt-2 p-2"
                style={{
                  backgroundColor: "#e3f2fd",
                  borderRadius: "4px",
                  fontSize: "12px",
                  color: "#1976d2",
                }}
              >
                <i className="fas fa-info-circle me-2"></i>
                Over the past six months, Ajay's online banking activity has
                increased, while his in-branch visits have declined compared to
                the preceding period.
              </div>
            </div>

            {/* Digital Engagement Trend */}
            <div>
              <h6
                className="mb-3"
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#495057",
                }}
              >
                Digital Engagement Trend
              </h6>
              <div
                style={{
                  height: "120px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #e9ecef",
                }}
              >
                <div className="text-center">
                  <i
                    className="fas fa-chart-bar"
                    style={{
                      fontSize: "24px",
                      color: "#6c757d",
                      marginBottom: "8px",
                    }}
                  ></i>
                  <div style={{ fontSize: "14px", color: "#6c757d" }}>
                    Digital engagement chart would be displayed here
                  </div>
                </div>
              </div>
              <div
                className="mt-2 p-2"
                style={{
                  backgroundColor: "#e3f2fd",
                  borderRadius: "4px",
                  fontSize: "12px",
                  color: "#1976d2",
                }}
              >
                <i className="fas fa-info-circle me-2"></i>
                Ajay's digital engagement has demonstrated a measurable increase
                over the past six months compared to the preceding period.
              </div>
            </div>
          </div>
        </div>

        {/* Activity Timeline */}
        <div className="col-md-4">
          <div
            className="card"
            style={{
              border: "1px solid #e9ecef",
              borderRadius: "8px",
              padding: "20px",
            }}
          >
            <h6
              className="mb-4"
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#495057",
              }}
            >
              Activity Timeline
            </h6>

            {/* Timeline items */}
            <div className="timeline">
              {[
                {
                  icon: "fas fa-globe",
                  title: "Web Engagement",
                  time: "1 day ago",
                  details: {
                    pages: "Home, RSPs",
                    source: "Email",
                    clicks: "4",
                  },
                },
                {
                  icon: "fas fa-credit-card",
                  title: "ATM",
                  time: "2 day ago",
                  details: {
                    activity: "Withdrawal",
                    amount: "$ 100",
                    location: "Main Street Branch\n1234 Main St.",
                  },
                },
                {
                  icon: "fas fa-share-alt",
                  title: "Social Media Share",
                  time: "2 weeks ago",
                  details: {
                    activity: "Social Media",
                    platform: "YELP",
                    outcome: "Linked",
                  },
                },
                {
                  icon: "fas fa-university",
                  title: "ATM",
                  time: "3 weeks ago",
                  details: {
                    activity: "Cheque Deposit",
                    amount: "$ 6,569.32",
                    location: "Main Street Branch",
                  },
                },
              ].map((item, index) => (
                <div key={index} className="timeline-item mb-4">
                  <div className="d-flex align-items-start">
                    <div
                      className="timeline-icon me-3"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px solid #e9ecef",
                      }}
                    >
                      <i
                        className={item.icon}
                        style={{ fontSize: "16px", color: "#6c757d" }}
                      ></i>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <h6
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#2c3e50",
                            marginBottom: "0",
                          }}
                        >
                          {item.title}
                        </h6>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#6c757d",
                          }}
                        >
                          {item.time}
                        </span>
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#6c757d",
                          lineHeight: "1.4",
                        }}
                      >
                        {Object.entries(item.details).map(
                          ([key, value], idx) => (
                            <div key={idx}>
                              <span
                                style={{
                                  fontWeight: "600",
                                  textTransform: "uppercase",
                                }}
                              >
                                {key}:
                              </span>{" "}
                              <span>{value}</span>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
